import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import axios from 'axios';
import { FaEdit, FaTrashAlt, FaPlus } from 'react-icons/fa';
import Profile from '../Profile/Profile';


import Breadcrumb from '../Breadcrumb';
import MetaHelmet from '../MetaHelmet';

const BlogIndex = () => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const routes = [
        { name: 'Home', path: '/dashboard' },
        { name: 'Blogs', path:'/blogs'}

    ];
   
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <MetaHelmet title={`Local Shouts | Blogs`}/>
        <div className="leads-container">
            <div className={`leads-content ${isSidebarOpen ? 'expanded' : 'collapsed'}`}>
              
                <Breadcrumb routes={routes}/>
                <div className="action-bar">
                    <Link to='/blogs/create' className='btn ls-btn main-btn'>
                        <FaPlus /> Create
                    </Link>
                </div>
                {/* <Profile setLead={setLead} /> */}
            </div>
            </div>
            </>
    );
};

export default BlogIndex;
